import type { FaireProductEntity } from "../../entity_types/product";

export const p_3gkg4srr88: FaireProductEntity = {
  token: "p_3gkg4srr88",
  type: "product",
  name: "Bauhaus Short Sleeve Sweater Tee - Fluorite",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/e7169e698d3dd5289c0232a8c1d4a809663329dbf6a32f935cd059bcb451296c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9db8dbd2e77f6fdd910a39cbbc1becf81420fb0b72e89b2ab8034afb6e26a5c1.jpeg",
    "https://cdn.faire.com/fastly/8cdd2fc860b72daa564b9117b8a4933894e80f691aa77ac91a629800642c5ed9.jpeg",
    "https://cdn.faire.com/fastly/0618c9f77bec1ec1cb24ada853e3ab05453b04e76171f0c6e9233fd65b5665f2.jpeg",
    "https://cdn.faire.com/fastly/3afa5ba81832b833d20777ec8a9c2442682a611d928caf49de0c12f8c4360618.jpeg"
  ],
  priceDollars: 75.6,
  description: "Our signature Bauhaus Tee—crafted from deadstock Pima cotton and designed with a bold jacquard knit. Lightweight, breathable, and easy to style, it’s a wardrobe essential.\n\n * Slightly cropped and boxy body \n * 100% Cotton \n * Artisan made in Peru with Fair Trade practices to maintain ethical and responsible integrity ",
  tags: [],
  msrpDollars: 168,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:24.071Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
